
const pdReadableFields = {
  title: {
    label: 'Incident title',
    icon: 'pd',
    key: 'incident.title',
  },

  number: {
    label: 'Incident number',
    icon: 'pd',
    key: 'incident.incident_number',
  },

  id: {
    label: 'Incident ID',
    icon: 'pd',
    key: 'incident.id',
  },

  description: {
    label: 'Description',
    icon: 'pd',
    key: 'log_entries.channel.details',
  },

  status: {
    label: 'Status',
    icon: 'pd',
    key: 'incident.status',
  },

  createdAt: {
    label: 'Created At',
    icon: 'pd',
    key: 'incident.created_at',
  },

  serviceName: {
    label: 'Service name',
    icon: 'pd',
    key: 'incident.service.summary',
  },

  escalationPolicyName: {
    label: 'Escalation policy name',
    icon: 'pd',
    key: 'incident.escalation_policy.summary',
  },

  impactedServices: {
    label: 'Impacted services',
    icon: 'pd',
    key: 'incident.impacted_services.name',
  },

  incidentUrl: {
    label: 'Incident URL',
    icon: 'pd',
    key: 'incident.html_url',
  },

  acknowledgements: {
    label: 'Acknowledgements',
    icon: 'pd',
    key: 'incident.acknowledgements.acknowledger.name',
  },

  urgency: {
    label: 'Urgency',
    icon: 'pd',
    key: 'incident.urgency',
  },

  priority: {
    label: 'Priority',
    icon: 'pd',
    key: 'incident.priority.summary',
  },

  assignee: {
    label: 'Incident assignee',
    icon: 'pd',
    key: 'incident.assignee',
  },

  lastChangedBy: {
    label: 'Last changed by',
    icon: 'pd',
    key: 'incident.last_status_change_by.summary',
  },

  lastChangedAt: {
    label: 'Last changed at',
    icon: 'pd',
    key: 'incident.last_status_change_at',
  },
};

export default pdReadableFields;
